export const actions = Object.freeze({
  READ: Symbol('read'),
  WRITE: Symbol('write'),
});

export const entities = Object.freeze({
  ACCOUNT: Symbol('account'),
  ADVERTISER: Symbol('advertiser'),
  APIKEY: Symbol('apikey'),
  AUDIENCEDATA: Symbol('audiencedata'),
  AUDIENCELOGIC: Symbol('audiencelogic'),
  AUDIENCEMOVIE: Symbol('audiencemovie'),
  AUDITCAMPAIGN: Symbol('auditcampaign'),
  AUDITCREATIVE: Symbol('auditcreative'),
  AUDITMOBILELINEITEM: Symbol('auditmobilelineitem'),
  AUDITLINEITEM: Symbol('auditlineitem'),
  AUDITPACKAGE: Symbol('auditpackage'),
  AUDITREPORTDEFINITION: Symbol('auditreportdefinition'),
  AUDITSITE: Symbol('auditsite'),
  AUDITUNIT: Symbol('auditunit'),
  AVAILS: Symbol('avails'),
  CAMPAIGN: Symbol('campaign'),
  CREATIVE: Symbol('creative'),
  CREATIVEFILE: Symbol('creativefile'),
  CREATIVEMEDIAOWNERAPPROVAL: Symbol('creativemediaownerapproval'),
  CREATIVEPREFETCH: Symbol('creativeprefetch'),
  CREATIVEPROPERTY: Symbol('creativeproperty'),
  CURATEDPACKAGE: Symbol('curatedpackage'),
  CUSTOMEVENT: Symbol('customevent'),
  DATAPROVIDER: Symbol('dataprovider'),
  DEMOGRAPHIC: Symbol('demographic'),
  DISCOUNTTYPE: Symbol('discounttype'),
  EXCHANGE: Symbol('exchange'),
  EXCHANGESETTING: Symbol('exchangesetting'),
  EXTERNALDEMOGRAPHIC: Symbol('externaldemographic'),
  GENERICGEOFENCE: Symbol('genericgeofence'),
  GEOFENCE: Symbol('geofence'),
  GEOFENCEGROUP: Symbol('geofencegroup'),
  LANGUAGE: Symbol('language'),
  LINEITEM: Symbol('lineitem'),
  LINEITEMCREATIVE: Symbol('lineitemcreative'),
  LINEITEMMEDIAOWNERAPPROVAL: Symbol('lineitemmediaownerapproval'),
  LINEITEMMETRICS: Symbol('lineitemmetrics'),
  LOCATION: Symbol('location'),
  MARGIN: Symbol('margin'),
  MARKET: Symbol('market'),
  MEASUREMENTDASHBOARD: Symbol('measurementdashboard'),
  MEDIAOWNER: Symbol('mediaowner'),
  MEDIATYPE: Symbol('mediatype'),
  MOBILELINEITEM: Symbol('mobilelineitem'),
  NETWORK: Symbol('network'),
  ORGANIZATION: Symbol('organization'),
  ORGANIZATIONDSP: Symbol('organizationdsp'),
  ORGANIZATIONSETTING: Symbol('organizationsetting'),
  ORGANIZATIONCUSTOMFIELD: Symbol('organizationcustomfield'),
  ORGANIZATIONPERFORMANCE: Symbol('organizationperformance'),
  PACKAGE: Symbol('package'),
  PERMISSIONS: Symbol('permissions'),
  PLAN: Symbol('plan'),
  PLAYLOG: Symbol('playlog'),
  PLAYLOGARCHIVE: Symbol('playlogarchive'),
  PRESALEHEATMAP: Symbol('presaleheatmap'),
  REPORT: Symbol('report'),
  REPORTDEFINITION: Symbol('reportdefinition'),
  REPORTEXECUTION: Symbol('reportexecution'),
  SITE: Symbol('site'),
  TARGETINGCRITERION: Symbol('targetingcriterion'),
  UNIT: Symbol('unit'),
  UNITFALLBACKCREATIVE: Symbol('unitfallbackcreative'),
  UNITFILTERS: Symbol('unitfilters'),
  UNITLANGUAGE: Symbol('unitlanguage'),
  UNITPACK: Symbol('unitpack'),
  UNITPROPERTY: Symbol('unitproperty'),
  USER: Symbol('user'),
});

class Permission {
  action: symbol;

  entity: symbol;

  constructor(action: symbol, entity: symbol) {
    this.action = action;
    this.entity = entity;
  }

  static fromApi([actionString, entityString]: string[]): Permission | null {
    const action = this.actionFromString(actionString);
    const entity = this.entityFromString(entityString);

    if (!action || !entity) {
      return null;
    }
    return new Permission(action, entity);
  }

  toApi(): string[] {
    return [this.action.description, this.entity.description];
  }

  static get actions(): { READ: symbol; WRITE: symbol } {
    return actions;
  }

  static get entities(): { [key: string]: symbol } {
    return entities;
  }

  static actionFromString(actionString: string): symbol | undefined {
    const key = Object.keys(actions).find(
      (val) => actions[val].toString().toLowerCase() === `Symbol(${actionString})`.toLowerCase(),
    );
    return actions[key];
  }

  static entityFromString(entityString: string): symbol | undefined {
    const key = Object.keys(entities).find(
      (val) => entities[val].toString().toLowerCase() === `Symbol(${entityString})`.toLowerCase(),
    );
    return entities[key];
  }

  equals(other: Permission): boolean {
    return this.action === other.action && this.entity === other.entity;
  }
}

export default Permission;
